import BaseModel from './BaseModel';

/** Class representing a payment. */
class Payment extends BaseModel {
    static MODE_CASH     = 'cash';
    static MODE_CARD     = 'card';
    static MODE_TRANSFER = 'transfer';
    static MODE_DEBIT    = 'debit';
    static MODE_CHECK    = 'check';

    constructor(properties) {
        super(properties);

        this.amount = Number(this.amount);
    }

    static modes() {
        return [
            Payment.MODE_CASH,
            Payment.MODE_CARD,
            Payment.MODE_TRANSFER,
            Payment.MODE_DEBIT,
            Payment.MODE_CHECK,
        ];
    }

    formatAmount() {
        return `${this.amount.toFixed(2)} €`;
    }
}

export default Payment;
